import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription, } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BranchEnums } from 'src/app/enum/branch-enums';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { DocumentSupportEnums } from 'src/app/enum/document-support-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { DocumentSupportPrintModel } from 'src/app/models/shopping/document-support-print.model';
import { DocumentSupportModel } from 'src/app/models/shopping/document-support.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { DocumentSupportService } from 'src/app/services/shopping/document-support.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { CopyDocumentSupportComponent } from '../copy-document-support/copy-document-support.component';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-register-document-support',
  templateUrl: './register-document-support.component.html',
  styleUrls: ['./register-document-support.component.scss'],
  standalone: false,
})
export class RegisterDocumentSupportComponent implements OnInit {
  @ViewChild('copyDocumentModal')
  copyDocumentModalComponent?: CustomModalComponent | null = null;
  @ViewChild('attachFileDocumentSupport') attachFileDocumentSupportComponent?: CustomModalComponent | null = null;

  accountingInterfaceCode: number | string = '';
  branchId: number = 0;
  branchListType = BranchEnums.sucursalesUsuario;
  bussinessDocumentsTypeId: number = BussinessDocumentsClassEnums.documSoporte;
  codeNameBranch: string | undefined = '';
  codeNameBussinessDocumentsType: string | undefined = '';
  codeNameEnterprise: string | undefined = '';
  codeNameProvider: string | undefined = '';
  companyId: number = 0;

  componentAttachFiles = CustomAttachFilesComponent;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  disabledProvider: boolean = false;
  disabledState: boolean = true;
  documentSupportContract: DocumentSupportModel = new DocumentSupportModel();
  documentSupportId: number = 0;
  documentSupportOrigin: number | string = '';
  documentSupportPrintModel: DocumentSupportPrintModel =
    new DocumentSupportPrintModel();
  documentSupportStateString: string = '';
  electronicInvoiceInterfaceCode: number | string = '';
  enableProvider = true;
  enterpriseId: number = 0;
  filteredListBussinessDocumentsTypes: any[] = [];
  finishLoadingPrint: boolean = false;
  formatModel: FormatModel = new FormatModel();
  formDocumentSupport: FormGroup = new FormGroup({});
  formDocumentSupportFooter: FormGroup = new FormGroup({});
  iconState: string = 'pi pi-lock-open';
  inputsForCopyDocument$ = new BehaviorSubject<any>({
    documentSupportId: 0,
    listBussinessDocumentsTypes: [],
  });
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listBussinessDocumentsTypes: any[] = [];
  listEnterprises: any[] = [];
  listFiles: any[] = [];
  listProvider: any[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  messageStateDocumentSupport: string = '';
  nameWindow: string = 'Captura Documento Soporte';
  output$ = new Subject<any>();
  outputForAttachFiles$ = new Subject<any>();
  page: number = 1;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  permissionUpdatable: boolean = false;
  printDocumentSupportFormat: boolean = false;
  projectName = ProjectName.projectName;
  providerId: number = 0;
  quantityDetails: number = 0;
  severityState: string = "danger";
  stateProvider: boolean = true;
  stateOpen: number = DocumentSupportEnums.open;
  stateText: string = 'Abierta';
  subscription: Subscription;
  titleState: string = '';
  titleStateDocumentSupport: string = '';
  updateListDetail: boolean = false;
  url: string = 'document-support';
  userAuthenticated: UserModel = new UserModel();
  visibleState: boolean = true;
  componentCopyDocument = CopyDocumentSupportComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private dateConverterService: DateConverterService,
    private documentSupportService: DocumentSupportService,
    private enterpriseService: EnterpriseService,
    private formatService: FormatService,
    private formBuilder: UntypedFormBuilder,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private headerService: HeaderService,
    private windowService: WindowService
  ) { }

  async ngOnInit(): Promise<void> {
    this.headerService.setTitle(this.nameWindow);
    this.validateForm(new DocumentSupportModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe((params) => {
      this.documentSupportId =
        Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'updateDocumentSupport':
          this.changeDocumentSupport(payload);
          this.updateListDetail = true;
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(
      AuthenticationContants.keyWindowsOpenedLocalStorage
    );
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex((x) => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(
          AuthenticationContants.keyWindowsOpenedLocalStorage,
          JSON.stringify(windowsOpened)
        );
      }
    }


    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.documentSupportId = 0;
    const modelDocumentSupport = new DocumentSupportModel();
    modelDocumentSupport.branchId = branchId;
    this.documentSupportContract = modelDocumentSupport;
    this.validateForm(modelDocumentSupport);
    try {
      this.listEnterprises = await firstValueFrom(
        this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)
      );
    } catch (error) {
      console.error('Error al buscar las empresas de la sucursal.', error);
    }
    this.location.replaceState(`/document-support/register`);
  }

  changeBussinessDocumentsType() {
    const branchId = this.formDocumentSupport.get('branchId')?.value;
    const enterpriseId = this.formDocumentSupport.get('enterpriseId')?.value;
    const bussinessDocumentsTypeId = this.formDocumentSupport.get(
      'bussinessDocumentsTypeId'
    )?.value;

    this.resetDocumentData();
    const modelDocumentSupport = new DocumentSupportModel();
    modelDocumentSupport.branchId = branchId;
    modelDocumentSupport.enterpriseId = enterpriseId;
    modelDocumentSupport.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    this.documentSupportContract = modelDocumentSupport;
    this.validateForm(modelDocumentSupport);
    this.location.replaceState(`/document-support/register`);
  }

  async changeConsecutive() {
    let consecutive = this.formDocumentSupport.get('consecutive')?.value;

    if (this.documentSupportContract.consecutive == consecutive) return;
    const branchId = this.formDocumentSupport.get('branchId')?.value;
    const enterpriseId = this.formDocumentSupport.get('enterpriseId')?.value;
    const bussinessDocumentsTypeId = this.formDocumentSupport.get(
      'bussinessDocumentsTypeId'
    )?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    } else if (
      bussinessDocumentsTypeId == null ||
      bussinessDocumentsTypeId == 0
    ) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.', 'Atención');
      return;
    } else if (consecutive == 0) {
      consecutive = null;
    }

    if (consecutive == null) {
      this.resetDocumentSupport(
        branchId,
        enterpriseId,
        bussinessDocumentsTypeId
      );
      return;
    }
    try {
      this.documentSupportContract = await firstValueFrom(
        this.documentSupportService.getDocumentSupportByKeysAsync(
          branchId,
          enterpriseId,
          bussinessDocumentsTypeId,
          consecutive
        )
      );
      this.documentSupportId = this.documentSupportContract.documentSupportId;
      this.updateCopyInputs();
      this.validateForm(this.documentSupportContract);
      this.location.replaceState(
        `/document-support/register/${this.documentSupportId}`
      );
    } catch (error) {
      this.handleDocumentSupportNotFound(
        branchId,
        enterpriseId,
        bussinessDocumentsTypeId,
        0
      );
      this.createNewDocumentSupport();
      console.error('Error al buscar el documento soporte por llaves', error);
    }
  }

  changeDocumentSupport(documentSupportModel: DocumentSupportModel) {
    this.documentSupportContract = documentSupportModel;
    this.validateForm(this.documentSupportContract);
  }

  async changeDocumentSupportState() {
    if (this.documentSupportContract.consecutive == 0) {
      this.toastHandlerService.showToast('warning', 'El documento soporte no está guardado.', 'Atención');
      return;
    }
    if (this.permissionUpdatable) {
      try {
        this.documentSupportContract = await firstValueFrom(
          this.documentSupportService.setActiveDocumentSupport(this.documentSupportContract.documentSupportId)
        );
        this.validateForm(this.documentSupportContract);
        this.toastHandlerService.showToast('success', 'El estado del documento soporte se modificó exitosamente.', 'Atención');
      } catch (error) {
        console.error('Error al modificar el estado del documento soporte.', error);
      }
    } else {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para cambiar estados de Documentos soporte. Comuníquese con el administrador del sistema.', '');
    }
  }

  changeEnterprise() {
    const branchId = this.formDocumentSupport.get('branchId')?.value;
    const enterpriseId = this.formDocumentSupport.get('enterpriseId')?.value;
    this.branchId = branchId;
    this.enterpriseId = enterpriseId;
    this.resetDocumentData();
    const modelDocumentSupport = new DocumentSupportModel();
    modelDocumentSupport.branchId = branchId;
    modelDocumentSupport.enterpriseId = enterpriseId;
    this.documentSupportContract = modelDocumentSupport;
    this.validateForm(this.documentSupportContract);
    this.location.replaceState(`/document-support/register`);
  }

  clearForm() {
    this.documentSupportContract = new DocumentSupportModel();
  }

  clickDocument() {
    let warningMessage: string | null = null;
    if (this.documentSupportContract.documentSupportId != 0) {
      if (!this.documentSupportContract.active) {
        warningMessage = 'El documento soporte se encuentra cerrado.';
      } else if (this.quantityDetails > 0) {
        warningMessage =
          'No es posible copiar desde, el documento soporte tiene detalle.';
      } else {
        this.copyDocumentModalComponent?.show();
        this.updateCopyInputs();
        return;
      }
    } else {
      warningMessage = 'Debe crear el encabezado del documento soporte.';
    }

    if (warningMessage) {
      this.toastHandlerService.showToast('warning', warningMessage, 'Atención');
    }
  }

  async createNewDocumentSupport() {
    if (this.permissionUpdatable) {
      this.resetDocumentData();
      this.documentSupportContract = new DocumentSupportModel();
      this.documentSupportContract.branchId = this.branchId;
      this.documentSupportContract.enterpriseId = this.enterpriseId;
      this.documentSupportContract.bussinessDocumentsTypeId =
        this.bussinessDocumentsTypeId;
      this.documentSupportContract.consecutive = 0;
      await this.validateForm(this.documentSupportContract);
      this.location.replaceState(`/document-support/register`);
    } else {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para crear Documentos. Comuníquese con el administrador del sistema.', '');
    }
  }

  async deleteDocumentSupport() {
    if (!this.validations()) return;

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar el documento soporte tiene detalle.', 'Atención');
      return;
    }

    if (this.permissionUpdatable) {
      const result = await Swal.fire({
        title: 'Atención',
        text: `Realmente desea eliminar el documento soporte ${this.documentSupportContract.consecutive} ?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
      });
      if (result.isConfirmed) {
        try {
          await firstValueFrom(
            this.documentSupportService.deleteDocumentSupport(
              this.documentSupportContract.documentSupportId
            )
          );
          this.toastHandlerService.showToast('success', 'El documento soporte fue eliminado exitosamente.', '');
          this.createNewDocumentSupport();
        } catch (error) {
          console.error('Error al eliminar el documento soporte.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para eliminar el documento soporte. Comuníquese con el administrador del sistema.', 'Atención');
    }
  }


  deleteFile(file: any) {
    if (this.documentSupportContract.documentSupportId != 0) {
      Swal.fire({
        title: 'Atención',
        text: "¿Realmente desea eliminar el adjunto seleccionado?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await firstValueFrom(this.documentSupportService.deleteFileToDocumentSupport(this.documentSupportContract.documentSupportId, file));
            this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
            this.getFilesToDocumentSupport();
          } catch (error) {
            console.error('Error catch:', error);
          }
        }
      });
    }
  }

  downloadFile(fileName: any) {
    if (this.documentSupportContract.documentSupportId != 0) {
      this.documentSupportService.downloadFileToDocumentSupport(this.documentSupportContract.documentSupportId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  async editDocument() {
    await this.getDocumentSupportById();
    this.validateForm(this.documentSupportContract);
    this.branchId = this.documentSupportContract.branchId;
    this.enterpriseId = this.documentSupportContract.enterpriseId;
    this.bussinessDocumentsTypeId =
      this.documentSupportContract.bussinessDocumentsTypeId;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists() {
    try {
      const [branches, enterprises, bussinessDocumentsTypes, providers] =
        await Promise.all([
          firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
          firstValueFrom(
            this.enterpriseService.getEnterprisesByBranchIdForSelect(
              this.branchId
            )
          ),
          firstValueFrom(
            this.documentSupportService.getAllBussinessDocumentsTypesForSelectAsync()
          ),
          firstValueFrom(
            this.documentSupportService.getAllProvidersForSelectAsync()
          ),
        ]);
      this.listBranches = branches;
      this.listEnterprises = enterprises;
      this.listProvider = providers;
      this.listBussinessDocumentsTypes = bussinessDocumentsTypes;
      this.filteredListBussinessDocumentsTypes =
        this.listBussinessDocumentsTypes;
      this.updateCopyInputs();
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getAccountingInterfaceCode(accountingInterfaceId: number | null) {
    if (accountingInterfaceId != null && accountingInterfaceId != 0) {
      this.accountingInterfaceCode = await firstValueFrom(
        this.documentSupportService.getAccountingInterfaceCode(
          accountingInterfaceId
        )
      );
    } else {
      this.accountingInterfaceCode = '';
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    this.filteredListBussinessDocumentsTypes =
      this.listBussinessDocumentsTypes.filter(
        (item) => item.branchId === this.branchId
      );
    this.branchId = branchId ?? 0;
    this.formDocumentSupport.controls['branchId'].patchValue(this.branchId);

    if (reload) {
      await this.changeBranch(this.branchId);
      this.getFirstEnterpriseByBranch(branchId);
    }
  }

  async getBussinessDocumentsType(
    bussinessDocumentsTypeId: number | null,
    reload: boolean
  ) {
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      const bussinessDocumentsType = this.listBussinessDocumentsTypes.find(
        (x) => x.value == bussinessDocumentsTypeId
      );
      if (bussinessDocumentsType) {
        this.formDocumentSupport.controls[
          'bussinessDocumentsTypeId'
        ].patchValue(bussinessDocumentsTypeId);
      }
    }
    if (reload) {
      this.changeBussinessDocumentsType();
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formDocumentSupport.get('branchId')?.value;
    const enterpriseId = this.formDocumentSupport.get('enterpriseId')?.value;
    const bussinessDocumentsTypeId = this.formDocumentSupport.get(
      'bussinessDocumentsTypeId'
    )?.value;
    let consecutive = this.formDocumentSupport.get('consecutive')?.value;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una Empresa.', 'Atención');
      return;
    } else if (
      bussinessDocumentsTypeId == null ||
      bussinessDocumentsTypeId == 0
    ) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.', 'Atención');
      return;
    } else if (consecutive == 0) {
      consecutive = null;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleDocumentSupportNavigation(
      buttonClick,
      branchId,
      enterpriseId,
      bussinessDocumentsTypeId,
      consecutive
    );
  }

  async getElectronicInvoiceInterfaceCode(
    electronicInvoiceInterfaceId: number | null
  ) {
    if (
      electronicInvoiceInterfaceId != null &&
      electronicInvoiceInterfaceId != 0
    ) {
      this.electronicInvoiceInterfaceCode = await firstValueFrom(
        this.documentSupportService.getElectronicInvoiceInterfaceCodeById(
          electronicInvoiceInterfaceId
        )
      );
    } else {
      this.electronicInvoiceInterfaceCode = '';
    }
  }

  async getFirstBranchEnterprise() {
    try {
      this.getBranch(this.mainBranchByUser.branchId, false);
      this.getFirstEnterpriseByBranch(this.mainBranchByUser.branchId);
    } catch (error) {
      console.error(
        'Error al buscar la sucursal del usuario autenticado.',
        error
      );
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(
        this.formatService.getFormatByCompanyAndCode(
          this.companyId!,
          FormatsEnums.documentSupport
        )
      );
  }

  async handleInitialState() {
    if (this.documentSupportId !== null && this.documentSupportId !== 0) {
      this.editDocument();
    } else {
      await this.getFirstBranchEnterprise();
      this.createNewDocumentSupport();
    }
  }

  private async handleDocumentSupportNavigation(
    buttonClick: any,
    branchId: number,
    enterpriseId: number,
    bussinessDocumentsTypeId: number,
    consecutive: number | null
  ) {
    const actionMap: Record<string, () => Promise<DocumentSupportModel>> = {
      first: () =>
        firstValueFrom(
          this.documentSupportService.getFirstDocumentSupportByKeysAsync(
            branchId,
            enterpriseId,
            bussinessDocumentsTypeId
          )
        ),
      previus: () =>
        firstValueFrom(
          this.documentSupportService.getPreviusDocumentSupportByKeysAsync(
            branchId,
            enterpriseId,
            bussinessDocumentsTypeId,
            consecutive
          )
        ),
      next: () =>
        firstValueFrom(
          this.documentSupportService.getNextDocumentSupportByKeysAsync(
            branchId,
            enterpriseId,
            bussinessDocumentsTypeId,
            consecutive
          )
        ),
      last: () =>
        firstValueFrom(
          this.documentSupportService.getLastDocumentSupportByKeysAsync(
            branchId,
            enterpriseId,
            bussinessDocumentsTypeId
          )
        ),
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetDocumentSupport(
        branchId,
        enterpriseId,
        bussinessDocumentsTypeId
      );
      return;
    }

    try {
      const documentSupport = await action();
      this.documentSupportContract = documentSupport;
      this.documentSupportId = documentSupport.documentSupportId;
      this.validateForm(documentSupport);
      this.location.replaceState(
        `/document-support/register/${this.documentSupportId}`
      );
    } catch (error) {
      this.handleDocumentSupportNotFound(
        branchId,
        enterpriseId,
        bussinessDocumentsTypeId,
        0
      );
      console.error(
        `Error al buscar el documento soporte (${buttonClick.target.id}).`,
        error
      );
    }
  }

  private handleDocumentSupportNotFound(
    branchId: number,
    enterpriseId: number,
    bussinessDocumentsTypeId: number,
    consecutive: number
  ): void {
    this.documentSupportContract = new DocumentSupportModel();
    this.documentSupportContract.documentSupportId = 0;
    this.documentSupportContract.branchId = branchId;
    this.documentSupportContract.enterpriseId = enterpriseId;
    this.documentSupportContract.bussinessDocumentsTypeId =
      bussinessDocumentsTypeId;
    this.documentSupportContract.consecutive = consecutive;
  }

  async getDocumentSupportById() {
    try {
      this.documentSupportContract = await firstValueFrom(this.documentSupportService.getDocumentSupportById(this.documentSupportId));
      this.documentSupportId = this.documentSupportContract.documentSupportId;
      if (this.branchId != this.documentSupportContract.branchId) {
        this.branchId = this.documentSupportContract.branchId;
        try {
          this.listEnterprises = await firstValueFrom(
            this.enterpriseService.getEnterprisesByBranchIdForSelect(
              this.branchId
            )
          );
        } catch (error) {
          console.error('Error al buscar las empresas de la sucursal.', error);
        }
      }
    } catch (error) {
      console.error('Error al buscar el documento soporte.', error);
    }
  }

  async getDocumentSupportOrigin(documentSupportOriginId: number | null) {
    if (documentSupportOriginId != null && documentSupportOriginId != 0) {
      try {
        this.documentSupportOrigin = await firstValueFrom(
          this.documentSupportService.getDocumentSupportOriginConsecutive(
            documentSupportOriginId
          )
        );
      } catch (error) {
        console.error('Error al buscar el documento soporte origen.', error);
      }
    } else {
      this.documentSupportOrigin = '';
    }
  }

  async getFilesToDocumentSupport() {
    try {
      this.listFiles = await firstValueFrom(this.documentSupportService.getFilesToDocumentSupport(this.documentSupportId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getEnterprise(enterpriseId: number | null, reload: boolean) {
    if (enterpriseId != null && enterpriseId != 0) {
      const enterprise = await firstValueFrom(
        this.enterpriseService.getEnterpriseById(enterpriseId)
      );
      if (enterprise) {
        this.enterpriseId = enterpriseId;
        this.formDocumentSupport.controls['enterpriseId'].patchValue(
          this.enterpriseId
        );
      } else {
        this.formDocumentSupport.controls['enterpriseId'].patchValue(null);
        this.enterpriseId = 0;
        return;
      }
    } else {
      this.formDocumentSupport.controls['enterpriseId'].patchValue(null);
      this.enterpriseId = 0;
    }

    if (reload) {
      this.changeEnterprise();
      this.getFirstBussinessDocumentsType();
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    this.mainBranchByUser = await firstValueFrom(
      this.userAuthenticatedService.branchObservable.pipe(
        filter((branch) => branch && branch.branchId !== 0)
      )
    );
    this.companyId = this.mainBranchByUser.companyId;
    this.branchId = this.mainBranchByUser.branchId;
  }

  async getFirstBussinessDocumentsType() {
    try {
      const response = await firstValueFrom(
        this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(
          BussinessDocumentsClassEnums.documSoporte,
          this.enterpriseId
        )
      );
      this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
      this.getBussinessDocumentsType(response.bussinessDocumentsTypeId, false);
      this.filteredListBussinessDocumentsTypes =
        this.listBussinessDocumentsTypes.filter(
          (item) => item.branchId === this.branchId
        );
      this.formDocumentSupport.controls['bussinessDocumentsTypeId'].patchValue(
        response.bussinessDocumentsTypeId
      );
    } catch (error) {
      console.error(
        'Error al buscar el tipo de documento del documento soporte.',
        error
      );
      this.filteredListBussinessDocumentsTypes = [];
    }
  }

  async getFirstEnterpriseByBranch(branchId: number | null) {
    if (branchId != null && branchId != 0) {
      try {
        const response = await firstValueFrom(
          this.enterpriseService.getFirstEnterpriseByBranch(branchId)
        );
        if (response) {
          this.enterpriseId = response.enterpriseId;
          this.getEnterprise(this.enterpriseId, false);
          this.getFirstBussinessDocumentsType();
        } else {
          this.enterpriseId = 0;
          this.formDocumentSupport.controls[
            'bussinessDocumentsTypeId'
          ].patchValue(null);
          return;
        }
      } catch (error) {
        console.error(
          'Error al buscar la primera empresa de la sucursal.',
          error
        );
      }
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(
      AuthenticationContants.keyWindowsOpenedLocalStorage
    );
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find((x) => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(
        AuthenticationContants.keyWindowsOpenedLocalStorage,
        JSON.stringify(windowsOpened)
      );
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    try {
      this.permissionUpdatable = await firstValueFrom(
        this.windowService.getPermissionProfileByUrl(this.url)
      );
      await this.getPermissionsForUserByWindow();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter((user) => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(
      this.optionWindowService.getPermissionsForUserByWindow(
        WindowEnums.DocumentSupport
      )
    );
  }

  async getPrintDocumentSupport(reload: boolean) {
    try {
      this.documentSupportPrintModel = await firstValueFrom(
        this.documentSupportService.printDocumentSupport(
          this.documentSupportContract.documentSupportId,
          reload
        )
      );
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  async getProvider(providerId: number | null) {
    const providerIdOld = this.formDocumentSupport.get('providerId')?.value;
    if (providerId != null && providerId != 0) {
      if (providerIdOld != providerId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast('warning', 'No puede cambiar el proveedor si el documento soporte tiene detalle.', 'Atención');
        setTimeout(
          () =>
            this.formDocumentSupport.controls['providerId'].patchValue(
              providerIdOld
            ),
          0
        );
      } else {
        const provider = this.listProvider.find((x) => x.value == providerId);
        if (provider) {
          this.formDocumentSupport.controls['providerId'].patchValue(
            providerId
          );
          this.stateProvider = provider.active;
        } else {
          this.formDocumentSupport.controls['providerId'].patchValue(0);
          this.stateProvider = false;
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast('warning', 'No puede limpiar el proveedor si el documento soporte tiene detalle.', 'Atención');
      } else {
        this.codeNameProvider = '';
        this.formDocumentSupport.controls['providerId'].setValue(0);
        this.stateProvider = false;
      }
    }
  }

  getQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
  }

  getUpdateDocumentSupport(documentSupport: DocumentSupportModel) {
    this.documentSupportContract = documentSupport;
    this.validateForm(this.documentSupportContract);
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/document-support']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async openAttachFile() {
    if (this.documentSupportContract.documentSupportId != 0 && this.documentSupportContract.documentSupportId != null) {
      await this.getFilesToDocumentSupport();
      this.attachFileDocumentSupportComponent && this.attachFileDocumentSupportComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado del documento soporte.', 'Atención');
    }
  }

  async printPage() {
    if (this.documentSupportContract.active) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir, el documento soporte está abierto.', 'Atención');
      return;
    }
    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getPrintDocumentSupport(true);

    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.documentSupportId != 0 && this.documentSupportId != null) {
      this.router.navigate([
        '/document-support/register/',
        this.documentSupportId,
      ]);
    } else {
      this.router.navigate(['/document-support/register']);
    }
  }

  resetDocumentData() {
    this.documentSupportId = 0;
    this.documentSupportOrigin = '';
    this.accountingInterfaceCode = '';
    this.electronicInvoiceInterfaceCode = '';
    this.providerId = 0;
    this.stateProvider = true;
    this.codeNameProvider = '';
    this.quantityDetails = 0;
  }

  private resetDocumentSupport(
    branchId: number,
    enterpriseId: number,
    bussinessDocumentsTypeId: number
  ): void {
    this.documentSupportId = 0;
    this.documentSupportContract = new DocumentSupportModel();
    this.documentSupportContract.branchId = branchId;
    this.documentSupportContract.enterpriseId = enterpriseId;
    this.documentSupportContract.bussinessDocumentsTypeId =
      bussinessDocumentsTypeId;
  }

  async send(): Promise<any> {
    if (this.formDocumentSupport.valid) {
      const modelDocumentSupport = this.formDocumentSupport
        .value as DocumentSupportModel;
      //Hago null, los campos que permiten ser nulos:
      if (modelDocumentSupport.observation == '')
        modelDocumentSupport.observation = null;
      if (modelDocumentSupport.cuds == '') modelDocumentSupport.cuds = null;

      if (this.documentSupportId == 0) {
        try {
          const response = await firstValueFrom(
            this.documentSupportService.createDocumentSupport(
              modelDocumentSupport
            )
          );
          this.toastHandlerService.showToast('success', 'El documento soporte fue creado exitosamente.', '');
          this.documentSupportContract = response;
          this.documentSupportId =
            this.documentSupportContract.documentSupportId;
          this.validateForm(this.documentSupportContract);
          this.location.replaceState(
            `/document-support/register/${this.documentSupportId}`
          );
        } catch (error) {
          console.error('Error al crear el documento soporte.', error);
        }
      } else {
        this.documentSupportContract.dateDocument =
          modelDocumentSupport.dateDocument;
        this.documentSupportContract.providerId =
          modelDocumentSupport.providerId;
        this.documentSupportContract.observation =
          modelDocumentSupport.observation;
        try {
          const response = await firstValueFrom(
            this.documentSupportService.updateDocumentSupport(
              this.documentSupportContract
            )
          );
          this.toastHandlerService.showToast('success', 'El documento soporte fue modificado exitosamente.', 'Atención');
          this.documentSupportContract = response;
          this.validateForm(this.documentSupportContract);
        } catch (error) {
          console.error('Error al actualizar el documento soporte.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.documentSupportService.attachFilesToDocumentSupport(this.documentSupportId, formData));
      await this.getFilesToDocumentSupport();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  updateCopyInputs() {
    this.inputsForCopyDocument$.next({
      listBussinessDocumentsTypes: this.filteredListBussinessDocumentsTypes,
      documentSupportId: this.documentSupportContract.documentSupportId,
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [DocumentSupportEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.documentSupportId !== 0,
      },
      [DocumentSupportEnums.close]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      },
    };

    const currentState = this.documentSupportContract.active
      ? DocumentSupportEnums.open
      : DocumentSupportEnums.close;
    const config = stateConfig[currentState];
    if (!config) return;
    this.severityState = config.severity;
    this.iconState = config.icon;
    this.titleState = config.title;
    this.stateText = config.text;
    this.disabledForm = config.isDisabled;
    this.disabledActions = config.isDisabled;
    this.disabledDetail = config.isDisabled;

    if (config.isDisabled) {
      this.formDocumentSupport.disable();
    } else {
      this.formDocumentSupport.enable();
    }

    const controls = this.formDocumentSupport.controls;
    if (config.enableConsecutive) {
      controls['consecutive'].enable();
    } else {
      controls['consecutive'].disable();
    }

    controls['branchId'].enable();
    controls['enterpriseId'].enable();
    controls['bussinessDocumentsTypeId'].enable();
    controls['swCopied'].disable();

    this.enableProvider = !config.isDisabled;
    this.formDocumentSupportFooter.disable();

    if (!this.permissionUpdatable) {
      this.formDocumentSupport.disable();
    }
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.documentSupportContract.consecutive,
      disabled: !this.documentSupportContract.active
    });
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para modificar documentos soporte. Comuníquese con el administrador del sistema', '');
      return false;
    }

    if (this.documentSupportContract.documentSupportId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado del documento soporte.', 'Atención');
      return false;
    }

    if (this.disabledForm && !this.documentSupportContract.active) {
      this.toastHandlerService.showToast('warning', 'No es posible modificar, el documento soporte no está abierto.', 'Atención');
      return false;
    }

    return true;
  }

  async validateDate() {
    if (
      this.documentSupportContract.documentSupportId != 0 &&
      this.documentSupportContract.documentSupportId != -1
    ) {
      const periodInvoiceOldId = this.documentSupportContract.rentalPeriodId;
      if (periodInvoiceOldId) {
        if (this.quantityDetails != 0) {
          this.toastHandlerService.showToast('warning', 'No se puede cambiar la fecha a un Período de alquiler diferente, mientras el documento tenga detalle.', 'Atención');
          this.disabledForm = true;
          return;
        }
      } else {
        this.toastHandlerService.showToast('warning', 'La fecha ingresada no existe en Período de alquiler.', 'Atención');
        this.disabledForm = true;
        return;
      }
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      enterpriseId: 'El campo empresa es obligatorio.',
      bussinessDocumentsTypeId: 'El campo tipo documento es obligatorio.',
      dateDocument: 'El campo fecha es obligatorio.',
      providerId: 'El campo proveedor es obligatorio.',
      observation: 'El campo observación permite máximo 250 carateres.',
    };

    Object.keys(controlMessages).forEach((control) => {
      if (this.formDocumentSupport.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención');
      }
    });
  }

  validateForm(documentSupport: DocumentSupportModel) {
    return new Promise((resolve) => {
      this.formDocumentSupport = this.formBuilder.group({
        branchId: [documentSupport.branchId, [Validators.required, Validators.min(1)],],
        enterpriseId: [documentSupport.enterpriseId, [Validators.required, Validators.min(1)],],
        bussinessDocumentsTypeId: [documentSupport.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)],],
        consecutive: [documentSupport.consecutive],
        dateDocument: [documentSupport.dateDocument ? this.dateConverterService.convertUtcToLocalDate(documentSupport.dateDocument) : null, [Validators.required],],
        providerId: [documentSupport.providerId, [Validators.required, Validators.min(1)],],
        observation: [documentSupport.observation, [Validators.maxLength(250)]], swCopied: [documentSupport.swCopied],
      });

      this.formDocumentSupportFooter = this.formBuilder.group({
        totalValue: [documentSupport.totalValue, [Validators.min(0), Validators.max(99999999999.99)],],
        noteCredit: [documentSupport.creditNotesValue, [Validators.min(0), Validators.max(99999999999.99)],],
        residue: [documentSupport.residueValue, [Validators.min(0), Validators.max(99999999999.99)],],
      });

      if (documentSupport.documentSupportId != 0) {
        this.getBussinessDocumentsType(documentSupport.bussinessDocumentsTypeId, false);
        this.getProvider(documentSupport.providerId);
        this.getDocumentSupportOrigin(documentSupport.documentSupportOriginId);
        this.getElectronicInvoiceInterfaceCode(
          documentSupport.electronicInvoiceInterfaceId
        );
        this.getBranch(documentSupport.branchId, false);
      }
      this.updateFormState();
      resolve(true);
    });
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (this.finishLoadingPrint) {
        print();
        resolve();
      } else {
        setTimeout(
          () => this.waitForComponenteImpresionToLoad().then(resolve),
          100
        );
      }
    });
  }
}
